module.exports = __webpack_public_path__ + "static/media/wide.098be8bd.jpg";